import { isArray } from 'lodash';
import { getBetName, getOutcomeName } from '@/utility/translationsHelper';

const mapRebet = (ticket) => {
  const bets = [];
  ticket.bets.forEach((bet) => {
    bets.push({
      round: bet.eventId,
      market: getBetName(bet),
      outcome: isArray(bet.value) ? bet.value.join(' ') : getOutcomeName(bet),
      outcomeIndex: isArray(bet.value) ? null : bet.outcome.value,
      value: bet.value,
      stake: bet.amount,
      odds: bet.category === 'SPECIAL' ? bet.odd : null,
      type: bet.type,
      system: bet.system,
      tax: bet.tax,
    });
  });
  return bets;
};

export default mapRebet;
